<!--<div class="row" style="width: 100%">-->
<!--  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">-->
<!--    <path fill="#04051d" fill-opacity="1"-->
<!--          d="M0,192L30,186.7C60,181,120,171,180,154.7C240,139,300,117,360,144C420,171,480,245,540,256C600,267,660,213,720,208C780,203,840,245,900,256C960,267,1020,245,1080,224C1140,203,1200,181,1260,186.7C1320,192,1380,224,1410,240L1440,256L1440,0L1410,0C1380,0,1320,0,1260,0C1200,0,1140,0,1080,0C1020,0,960,0,900,0C840,0,780,0,720,0C660,0,600,0,540,0C480,0,420,0,360,0C300,0,240,0,180,0C120,0,60,0,30,0L0,0Z"></path>-->
<!--  </svg>-->

<!--</div>-->
<div id="about" class="container mt-3">
  <h2 data-aos-duration="2500" data-aos="flip-down" class="justify-content-center text-white">A Propos de Moi</h2>
  <div class="row">
    <div data-aos="zoom-in" data-aos-duration="3000" class="col-md-6  align-middle">
      <p class="mt-5 text-white" style="font-size: 18px;">
        Bonjour, je suis Abidar Yassine. Actuellement je suis un élève Ingénieur en deuxième année System d'information
        && Réseaux Informatique à la faculté des sciences et technique Marrakech. passionné par le developpemt web &
        mobile & AI.
      </p>
      <div class="d-flex justify-content-between">
        <div class="p-2">
          <a href="https://www.linkedin.com/in/yassine-abidar-56bb4819b/"><i style="color: #0077B5;"
              class="fab fa-linkedin-in fa-3x"></i></a>
        </div>
        <div class="p-2">
          <a href="https://github.com/AbidarYassine">
            <i class="fab fa-github fa-3x text-white"></i>
          </a>
        </div>
        <div class="p-2">
          <a href="https://twitter.com/YassineAbidar5">
            <i style="color:#1DA1F2" class="fab fa-twitter fa-3x">
            </i>
          </a>
        </div>
      </div>
    </div>
    <div id="img_to_hide" data-aos-duration="3000" data-aos="zoom-in-up" class="col-md-6">
      <img src="../../../assets/bgMe.png" alt="Image">
    </div>
  </div>
</div>
<!--<div class="row container">-->
<!--  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">-->
<!--    <path fill="#04051d" fill-opacity="1"-->
<!--          d="M0,192L30,186.7C60,181,120,171,180,154.7C240,139,300,117,360,144C420,171,480,245,540,256C600,267,660,213,720,208C780,203,840,245,900,256C960,267,1020,245,1080,224C1140,203,1200,181,1260,186.7C1320,192,1380,224,1410,240L1440,256L1440,320L1410,320C1380,320,1320,320,1260,320C1200,320,1140,320,1080,320C1020,320,960,320,900,320C840,320,780,320,720,320C660,320,600,320,540,320C480,320,420,320,360,320C300,320,240,320,180,320C120,320,60,320,30,320L0,320Z"></path>-->
<!--  </svg>-->
<!--</div>-->